import React, {Component} from "react";

export default class HistoryPopoverTitle extends Component {

    constructor (props) {

        super(props);

        this.state = {

        };

    }

    render () {

        switch (this.props.historyType) {

        case "demand":
            return (<>
{`${this.props?.pageText?.historyPopoverDemandTitle ?? ''} ${this.props.partNumber ?? 'No part number'}`}
</>);
        case "suggested":
            return (<>
{`${this.props?.pageText?.historyPopoverSuggestedTitle ?? ''} ${this.props.partNumber ?? 'No part number'}`}
</>);
        case "ordered":
            return (<>
{`${this.props?.pageText?.historyPopoverOrderedTitle ?? ''} ${this.props.partNumber ?? 'No part number'}`}
</>);

        }

    }

}
